
import React from "react";
import { User } from "lucide-react";

const ProfileHeader = () => {
  return (
    <div className="flex items-center gap-4 mb-8">
      <div className="bg-primary/10 p-3 rounded-full">
        <User className="h-8 w-8 text-primary" />
      </div>
      <div>
        <h1 className="text-3xl font-bold">Your Profile</h1>
        <p className="text-muted-foreground">
          Share information about yourself to personalize your experience
        </p>
      </div>
    </div>
  );
};

export default ProfileHeader;
